/**
 * The account-tier offer, in one place.
 *
 * The popup and the in-page download card both render from this, so the rates
 * can never drift apart between the two surfaces.
 */

const TIERS = [
  {
    key: "pro",
    label: "PRO",
    jodiRate: "10 → ₹950",
    harufRate: "100 → ₹950",
    commission: "1%",
    commissionNote: "हर डिपॉजिट पर",
  },
  {
    key: "max",
    label: "MAX",
    jodiRate: "10 → ₹900",
    harufRate: "100 → ₹900",
    commission: "5%",
    commissionNote: "हर डिपॉजिट पर",
  },
];

const MIN_DEPOSIT = "₹30";
const REFER_COMMISSION = "1% कमीशन Lifetime";

const OFFER_SUMMARY_HI =
  "PRO अकाउंट में 10 का 950 रेट + हर डिपॉजिट पर 1% कमीशन, और MAX अकाउंट में 10 का 900 रेट + हर डिपॉजिट पर 5% कमीशन। Minimum deposit मात्र ₹30 से शुरू।";

const OFFER_SUMMARY_EN =
  "Two account types: PRO gives a 10 → 950 rate with 1% commission on every deposit, MAX gives a 10 → 900 rate with 5% commission on every deposit. Minimum deposit starts at just ₹30.";

module.exports = {
  TIERS,
  MIN_DEPOSIT,
  REFER_COMMISSION,
  OFFER_SUMMARY_HI,
  OFFER_SUMMARY_EN,
};
